import { ACCOUNT_UI_API_VI, IMAUTH_API_V1 } from "./constants"

export const updatePasswordUrl = (execution: string, key: string) => {
    return `/${IMAUTH_API_V1}/login-actions?execution=${execution}&key=${key}`
}

export const verifyUserNameAPI = (userName: string, state: string, locale: string, key: string ): string => {
    return `/${IMAUTH_API_V1}/login/verify?username=${userName}&state=${state}&locale=${locale}&key=${key}`
  }

export const getLocales = (): string => {
    return `/${IMAUTH_API_V1}/translation/locales`
  }

export const passwordLogin = (state: string): string => {
    return `/${IMAUTH_API_V1}/login/verify-password?state=${state}`
  }

export const linkProfile = (): string => {
  return `/${IMAUTH_API_V1}/link-profile`
}

export const configureTotp = (): string => {
  return `/${IMAUTH_API_V1}/login/configure-otp`
}

export const verifyTotp = (): string => {
  return `/${IMAUTH_API_V1}/login/verify-otp`
}

export const forgotPassword = (userName: string): string => {
  return `/${ACCOUNT_UI_API_VI}/user/${userName}/forgot-password`
}

export const forgotUsername = (email: string): string => {
  return `/${ACCOUNT_UI_API_VI}/user/${email}/forgot-username`
}

export const fetchCustomLoginSettings = (): string => {
  return `/${IMAUTH_API_V1}/login/customization`
}